import React, { useMemo } from 'react';
import { Chip } from '@material-ui/core';
import {
  dateHelper,
  enumHelper,
  flagHelper,
  isSkeletonLoading,
  READER_REQUEST_STATUSES,
  READER_REQUEST_TYPES
} from 'shared';
import { FILTER_TYPE } from 'shared/ViewTable/AdvancedFilters';

export function useReaderRequestsBuildTable(inputs, t) {
  const requestStatusesElements = useMemo(() => {
    return enumHelper.enumToFilter(READER_REQUEST_STATUSES, t, 'statuses');
  }, [t]);
  const requestTypesElements = useMemo(() => {
    return enumHelper.enumToFilter(READER_REQUEST_TYPES, t, 'types');
  }, [t]);

  const headCells = useMemo(() => {
    return [
      {
        id: 'requestNumber',
        numeric: false,
        disablePadding: false,
        label: t('properties.requestNumber')
      },
      {
        id: 'requestDate',
        numeric: false,
        disablePadding: false,
        label: t('properties.requestDate'),
        filterType: FILTER_TYPE.DATE
      },
      {
        id: 'receptionDate',
        numeric: false,
        disablePadding: false,
        label: t('properties.receptionDate'),
        filterType: FILTER_TYPE.DATE
      },
      { id: 'product', numeric: false, disablePadding: false, label: t('properties.product'), ellipsis: true },
      {
        id: 'requestType',
        numeric: false,
        disablePadding: false,
        label: t('properties.requestType'),
        filterType: FILTER_TYPE.COMBO,
        filterValues: requestTypesElements
      },
      {
        id: 'requestStatus',
        numeric: false,
        disablePadding: false,
        label: t('properties.requestStatus'),
        filterType: FILTER_TYPE.COMBO,
        filterValues: requestStatusesElements
      },
      {
        id: 'boxesAmountToRead',
        numeric: true,
        disablePadding: false,
        label: t('properties.boxesAmountToRead')
      }
    ];
  }, [t, requestStatusesElements, requestTypesElements]);

  const rows = useMemo(() => {
    if (!inputs) {
      return [];
    }
    return inputs.items.map(request => ({
      product: request.product,
      requestDate: isSkeletonLoading(request.requestDate)
        ? request.requestDate
        : request.requestDate
          ? dateHelper.toShortDate(request.requestDate)
          : '',
      receptionDate: isSkeletonLoading(request.receptionDate)
        ? request.receptionDate
        : request.receptionDate
          ? dateHelper.toShortDate(request.receptionDate)
          : '',
      boxesAmountToRead: request.boxesAmountToRead,
      requestStatus: isSkeletonLoading(request.requestStatus)
        ? request.requestStatus
        : requestStatusesElements &&
          requestStatusesElements.filter(r => r.value === request.requestStatus.toString())[0]?.name,
      requestType: isSkeletonLoading(request.requestType)
        ? request.requestType
        : flagHelper
            .convertIntToArray(READER_REQUEST_TYPES, request.requestType, t, 'types')
            .map((type, index) => (
              <Chip key={index} label={t(type?.name)} style={{ marginRight: 5, marginTop: 2, marginBottom: 2 }} />
            )),
      responseFileUrl: request.responseFileUrl,
      errors: request.errors,
      requestNumber: request.requestNumber,
      id: request.id
    }));
  }, [inputs, requestStatusesElements, t]);

  return { headCells, rows };
}
